import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultClientOrientation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultClientOrientation' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b> <center> CLIENT ORIENTATION  </center> </b>
                </p>
                <p className='w-750'>
                    <b> POLICY:</b> It is the agency"s policy to ensure upon admissions to Jackson Hands of Change"s program that a confidential and efficient orientation is provided to the client and the client"s family.
                </p>
                <p className='w-750'>
                    <b> PROCEDURE:</b> Each client and the client"s family will receive orientation concerning:

                    <ol>
                        <li>
                            communication/input policies regarding:
                            <ol>
                                <li>quality of care, outcome achievement, client satisfaction explanation of Jackson Hands of Chang</li>
                                <li>mission/philosophy,</li>
                                <li>services, activities, and therapeutic interventions expectations</li>
                                <li>Clients rights and responsibilities;</li>
                                <li>Informed consent to treat</li>
                                <li>hours of operation; access to after-hour services & crisis number</li>
                                <li>24-hour on call policy</li>
                                <li>code of ethics</li>
                                <li>confidentiality policy authorization to provide treatment;</li>
                                <li>grievance and appeal procedures</li>
                            </ol>

                        </li>
                        <li>Explanation regarding the processes and purpose of assessment,</li>
                        <li>
                            A description of how the person centered Treatment Plan will be developed
                            <ol>
                                <li>The potential course of treatment/services. i.e. treatment planning, treatment, transitional criteria, and discharge planning referrals, and follow-up.</li>
                                <li>The person"s participation in goal development and achievement - proposed treatment to include treatment methodology, duration, goals and services</li>
                                <li>adverse reactions to treatment; Possible consequences, complications and/or risks to treatment</li>
                                <li>How motivational incentives may be used; treatment alternatives;</li>
                            </ol>
                        </li>
                        <li>Expectation of family involvement</li>
                        <li>Orientation - with facilities, including emergency exits, fire suppression equipment, and first aid kits.</li>
                        <li>
                            program rules that identify:
                            <ol>
                                <li>Any restrictions the program may place on clients.</li>
                                <li>Events, behaviors, or attitudes that may lead to the loss of rights or privileges for the client.</li>
                                <li>Means by which the client may regain rights or privileges that have been restricted.</li>
                            </ol>
                        </li>
                        <li>Explanation of policy on coming to services under the influence</li>
                        <li>Expectations for legally required appointments, sanctions, or court notifications. Requirements for follow-up for mandated clients, regardless of his/her discharge outcome; If ordered into treatment by court, you are expected to appear at court when ordered; any violation must be reported to court which could lead to dismissal and punishment as court sees fit</li>
                        <li>Risks and consequences of non-compliance " Explanation of the need to keep therapy and psychiatric appointments.</li>
                        <li>Identification of service coordinator " therapist name and contact information.</li>
                        <li>Education regarding Advanced Directives, where appropriate. </li>
                    </ol>

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>

                    </tr>
                </table>


            </div>
        </form>

    )
}